import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfirmationDialogConfig } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  private confirmationSubject = new Subject<{
    config: ConfirmationDialogConfig;
    resolve: (result: boolean) => void;
  }>();

  confirmation$ = this.confirmationSubject.asObservable();

  confirm(config: Partial<ConfirmationDialogConfig>): Promise<boolean> {
    const fullConfig: ConfirmationDialogConfig = {
      title: 'Bestätigung erforderlich',
      message: 'Sind Sie sicher?',
      confirmText: 'Bestätigen',
      cancelText: 'Abbrechen',
      confirmButtonClass: 'btn-danger',
      icon: 'warning',
      ...config
    };

    return new Promise<boolean>((resolve) => {
      this.confirmationSubject.next({
        config: fullConfig,
        resolve
      });
    });
  }

  // Convenience methods for common use cases
  confirmDelete(itemName: string = 'Element'): Promise<boolean> {
    return this.confirm({
      title: `${itemName} löschen`,
      message: `Möchten Sie dieses ${itemName.toLowerCase()} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      confirmText: 'Löschen',
      cancelText: 'Abbrechen',
      confirmButtonClass: 'btn-danger',
      icon: 'danger'
    });
  }

  confirmDeactivate(itemName: string = 'Element'): Promise<boolean> {
    return this.confirm({
      title: `${itemName} deaktivieren`,
      message: `Möchten Sie dieses ${itemName.toLowerCase()} wirklich deaktivieren?`,
      confirmText: 'Deaktivieren',
      cancelText: 'Abbrechen',
      confirmButtonClass: 'btn-warning',
      icon: 'warning'
    });
  }

  confirmActivate(itemName: string = 'Element'): Promise<boolean> {
    return this.confirm({
      title: `${itemName} aktivieren`,
      message: `Möchten Sie dieses ${itemName.toLowerCase()} aktivieren?`,
      confirmText: 'Aktivieren',
      cancelText: 'Abbrechen',
      confirmButtonClass: 'btn-primary',
      icon: 'info'
    });
  }
}